import { render, staticRenderFns } from "./LeadDistributionOwner.vue?vue&type=template&id=2c9e9e29&scoped=true&"
import script from "./LeadDistributionOwner.vue?vue&type=script&lang=js&"
export * from "./LeadDistributionOwner.vue?vue&type=script&lang=js&"
import style0 from "./LeadDistributionOwner.vue?vue&type=style&index=0&id=2c9e9e29&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9e9e29",
  null
  
)

export default component.exports